import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllTermoEPIUseCase } from "../../../presentation/useCases/read/get_all_termo_epi_use_case";
import { TermoEpi } from "../../models/termo_epi";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class GetAllTermoEPIUseCase
  extends BasePaginatedUseCase<TermoEpi>
  implements IGetAllTermoEPIUseCase
{
  constructor(private readonly repository: IGestaoEpiRepository) {
    super();
  }

  async execute(
    codigo?: string,
    descricao?: string,
    nome?: string,
    status?: number,

    currentPage?: number,
    rowsPerPage?: number,
  ): Promise<void> {
    const result = await this.repository.getAllTermosEPI(
      codigo ?? "",
      descricao ?? "",
      nome ?? "",
      status ?? 2,

      currentPage,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
